import { omanConfig } from '../oman.config'
import type { TOmanFormatData } from '../types/oman.types'

declare global {
    interface Window {
        gtag?: (...args: unknown[]) => void
        dataLayer?: unknown[]
    }
}

const getGa4Id = () => omanConfig.tracking.ga4

const ensureGtag = () => {
    const ga4Id = getGa4Id()
    if (!ga4Id) return false
    if (typeof window.gtag === 'function') return true

    window.dataLayer = window.dataLayer ?? []
    window.gtag = function gtag(...args: unknown[]) {
        window.dataLayer!.push(args)
    }
    window.gtag('js', new Date())
    window.gtag('config', ga4Id)

    const script = document.createElement('script')
    script.async = true
    script.src = `https://www.googletagmanager.com/gtag/js?id=${ga4Id}`
    document.head.appendChild(script)

    return true
}

export const trackPurchaseEvent = (paymentId: string, formatData: TOmanFormatData) => {
    if (!ensureGtag() || !window.gtag) return

    const items = (formatData.items ?? []).map(item => ({
        item_id: item.item_code,
        item_name: item.name,
        price: item.price,
        quantity: item.qty
    }))

    window.gtag('event', 'purchase', {
        transaction_id: paymentId,
        value: formatData.total ?? 0,
        currency: omanConfig.currency.code,
        shipping: formatData.freight ?? 0,
        items,
        category: formatData.hasSubscription ? 'subscribe' : 'onetime'
    })
}
